export const localization = {
  "kz": {
    mainInfo: {
      name: "Жұмыс берушнің аты-жөні",
      position: "Жұмыс орны",
      places: "Филиалдар саны",
      vacancies: "Бос жұмыс орындар",
      hired: "Жұмысқа алынғандар саны"
    },
    additionalInfo: {
      mainInfo: "Негізгі ақпарат",
      description: "eDiploma – JASAIM командасы әзірлеген, құжатты бұрмалау мүмкіндігін жоққа шығаратын NFT (нұсқаланбайтын токен) форматындағы түлектердің қағаз дипломдарын цифрлауды қамтамасыз ететін онлайн платформа. eDiploma порталы түлектерге, жұмыс берушілерге және университет әкімшілігіне дипломдармен жеке кабинеттер арқылы өзара әрекеттесу мүмкіндігін береді, бітірушілердің біліктілігін тексеру және растау процестерін жеңілдетеді."
    },
    studentsPanel: {
      favorite: "Таңдаулылар",
      filter: "Фильтр",
      search: "Іздеу",
      Student: {
        name: "Толық аты-жөні",
        major: "Мамандық",
        graduationYear: "Аяқталған жылы"
      },
      noFavorites: "Таңдаулылар әлі қосылмаған",
    },
    phone: "Телефон нөмірі",
    email: "Email",
  },
  "ru": {
    mainInfo: {
      name: "Ф.И. Работодателя",
      position: "Должность",
      places: "Кол-во филлиалов",
      vacancies: "Открытых ваканскии",
      hired: "Нанято сотрудников",
    },
    additionalInfo: {
      mainInfo: "Основная информация",
      description: "eDiploma - это онлайн-платформа, разрабатываемая командой JASAIM, которая предоставляет оцифровку бумажных дипломов выпускников в формате NFT (невзаимозаменяемые токены), что позволяет исключить возможность подделки документов. Портал eDiploma предоставляет возможность выпускникам, работодателям и администрации университетов взаимодействовать с дипломами через личные кабинеты, облегчая процессы проверки и подтверждения квалификации выпускников."
    },
    studentsPanel: {
      favorite: "Избранные",
      filter: "Фильтр",
      search: "Найти",
      Student: {
        name: "Ф.И.О.",
        major: "Специальность",
        graduationYear: "Год выпуска",
      },
      noFavorites: "Избранные пока не добавлены",
    },
    phone: "Номер телефона",
    email: "Email",
  },
  "en": {
    mainInfo: {
      name: "Employer's Name",
      position: "Position",
      places: "Number of Branches",
      vacancies: "Open Vacancies",
      hired: "Employees Hired"
    },
    additionalInfo: {
      mainInfo: "Main Information",
      description: "eDiploma is an online platform developed by the JASAIM team that provides digitization of graduates' paper diplomas in the form of NFTs (Non-Fungible Tokens), eliminating the possibility of document forgery. The eDiploma portal enables graduates, employers, and university administration to interact with diplomas through personal accounts, simplifying the processes of verification and confirmation of graduates' qualifications."
    },
    studentsPanel: {
      favorite: "Favorites",
      filter: "Filter",
      search: "Search",
      Student: {
        name: "Full Name",
        major: "Major",
        graduationYear: "Graduation Year"
      },
      noFavorites: "No favorites yet",
    },
    phone: "Phone number",
    email: "Email",
  },
}

export const employerData = {
    "phone":{
        'ru': 'Номер телефона',
        'kz': 'Телефон номері',
        'en': 'Phone'
    },
    "email": {
        'ru': 'Почта',
        'kz': 'Пошта',
        'en': 'Email'
    },
    "address": {
        'ru': 'Распололжение',
        'kz': 'Мекен жайы',
        'en': 'Location'
    },
};

export const titles = {
    'ru': {
        data: 'Данные организации',
        about: 'О компании',
    },
    'kz': {
        data: 'Мекеме жайлы деректер',
        about: 'Компания туралы',
    },
    'en': {
        data: 'Organization data',
        about: 'About company',
    },
}
export const employerNumData = {
    "branches_amount": {
        'ru': 'Кол-во филиалов',
        'kz': 'Филиалдар саны',
        'en': 'Branches'
    },
    "vacancy_amount": {
        'ru': 'Открытых вакансий',
        'kz': 'Ашық вакансиялар',
        'en': 'Open positions'
    },
    "hired_amount": {
        "ru": "Нанято сотрудников",
        "kz": "Тағайындалған жұмысшылар",
        "en": "Hired employees"
    },
};
